module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', {
    staticClass: "tocol"
  }, [_c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/0_chapter1thelonelyking"
    }
  }, [_vm._v("CHAPTER 1 - THE LONELY KING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/1_chapter2murderonthetable"
    }
  }, [_vm._v("CHAPTER 2 - MURDER ON THE TABLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/2_chapter3weirdcaptain"
    }
  }, [_vm._v("CHAPTER 3 - WEIRD CAPTAIN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/3_chapter4perfectsolution"
    }
  }, [_vm._v("CHAPTER 4 - PERFECT SOLUTION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/4_chapter5truemurdermethod"
    }
  }, [_vm._v("CHAPTER 5 - TRUE MURDER METHOD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/5_chapter6thepowerbehindit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6 - THE POWER BEHIND IT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/6_chapter7jadependant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7 - JADE PENDANT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/7_chapter8shiftstudent",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8 - SHIFT STUDENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/8_chapter9affectedmilkteashop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9 - AFFECTED MILK TEA SHOP")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/9_chapter10blacknightconspiracy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10 - BLACK NIGHT CONSPIRACY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter11chip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11 - CHIP")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter12dream",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12 - DREAM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter13jadependant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13 - JADE PENDANT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter14theoriginofjadependant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14 - THE ORIGIN OF JADE PENDANT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter15twopeoplediarrhoea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15 - TWO PEOPLE DIARRHOEA?")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter16mandateofthepresident",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16 - MANDATE OF THE PRESIDENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter17unexpectedidentity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17 - UNEXPECTED IDENTITY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter18gobacktothemilkteashop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18 - GO BACK TO THE MILK TEA SHOP")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter19zhaoyaqing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19 - ZHAO YA QING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter20tohitawallistoretreatinordertoadvance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20 - TO HIT A WALL IS TO RETREAT IN ORDER TO ADVANCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter21expense",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21 - EXPENSE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter22recollection",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22 - RECOLLECTION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter23troublewithzhaoyating",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23 - TROUBLE WITH ZHAO YATING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter24zhaogroupsdestruction",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24 - ZHAO GROUP'S DESTRUCTION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter25yanruxuansmethods",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25 - YAN RU XUAN'S METHODS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/25_chapter26molu",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26 - MO LU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/26_chapter27crown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27 - CROWN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter28pastlife1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28 - PAST LIFE(1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/28_chapter29pastlife2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29 - PAST LIFE(2)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/29_chapter30pastlife3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30 - PAST LIFE(3)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter31pastlife4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31 - PAST LIFE(4)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/31_chapter32pastlife5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32 - PAST LIFE(5)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter33itturnedouttobeadream",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33 - IT TURNED OUT TO BE A DREAM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/33_chapter34confession",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 34 - CONFESSION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter35together",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 35 - TOGETHER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/35_chapter36cues",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 36 - CUES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/36_chapter37four",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 37 - FOUR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/37_chapter38choosetohide",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 38 - CHOOSE TO HIDE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/38_chapter39thenewsituationintheclass",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 39 - THE NEW SITUATION IN THE CLASS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter40classmate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 40 - CLASSMATE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/40_chapter41playground",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 41 - PLAYGROUND")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter42ruse",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 42 - RUSE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter43censure",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 43 - CENSURE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/43_chapter44scolding",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 44 - SCOLDING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter45disciple",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 45 - DISCIPLE?")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter46carbuncle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 46 - CARBUNCLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter47gangannihilate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 47 - GANG ANNIHILATE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/47_chapter48findmaster",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 48 - FIND MASTER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter49departure",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 49 - DEPARTURE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter50decision",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 50 - DECISION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter51awakening",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 51 - AWAKENING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter52snowdrop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 52 - SNOWDROP")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter53rainwater",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 53 - RAINWATER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter54away",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 54 - AWAY")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0